import { Modal, Table, Button } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
    open: boolean;
    onClose: () => void;
}

export default function QuickMessageModal({
    open,
    onClose,
}: Props) {
    const { t } = useTranslation();
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const data = [
        {
            key: 1,
            name: "Chào khách mới",
            createdAt: "01/03/2026 09:20",
            updatedAt: "02/03/2026 10:15",
        },
        {
            key: 2,
            name: "Nhắc thanh toán lịch hẹn",
            createdAt: "28/02/2026 14:05",
            updatedAt: "01/03/2026 08:30",
        },
        {
            key: 3,
            name: "Chăm sóc sau bán",
            createdAt: "25/02/2026 16:40",
            updatedAt: "27/02/2026 11:12",
        },
    ];

    return (
        <Modal
            title={t('cd.quick_msg_title')}
            open={open}
            onCancel={onClose}
            footer={null}
            width={700}
            destroyOnClose
            className="dark:[&_.ant-modal-content]:bg-[#141414]
                dark:[&_.ant-modal-header]:bg-[#141414]
                dark:[&_.ant-modal-title]:text-gray-200
                dark:[&_.ant-modal-close]:text-gray-400"
        >
            <Table
                scroll={{ x: "max-content" }}
                rowSelection={{
                    type: "radio",
                    selectedRowKeys,
                    onChange: (keys) => setSelectedRowKeys(keys),
                }}
                columns={[
                    { title: t('cd.quick_msg_col_name'), dataIndex: "name" },
                    { title: t('cd.quick_msg_col_created'), dataIndex: "createdAt" },
                    { title: t('cd.quick_msg_col_updated'), dataIndex: "updatedAt" },
                ]}
                dataSource={data}
                pagination={false}
                className="custom-ant-table"
            />

            <div className="flex justify-end gap-2 mt-4">
                <Button onClick={onClose}>
                    {t('cd.cancel')}
                </Button>

                <Button
                    type="primary"
                    disabled={!selectedRowKeys.length}
                >
                    {t('cd.quick_msg_select')}
                </Button>
            </div>
        </Modal>
    );
}